import { z } from "zod";

export const sessionCartSchema = z.object({
  id: z.number().nullable(),
  count: z.number().int(),
});

// Mirrors the assisted customer payload stored in
// `ASSISTED:{agentUserId}` in Redis.
export const sessionAssistedCustomerSchema = z.object({
  userId: z.number().int(),
  profileId: z.number().int(),
});

export const sessionUserBasicInfoSchema = z.object({
  name: z.string().min(1),
  email: z.string().optional(),
  phone: z.string().optional(),
});

export const sessionGstSchema = z.object({
  gstNumber: z.string().optional(),
  isGstVerified: z.boolean().optional(),
  companyName: z.string().optional(),
  constitutionOfBusiness: z.string().optional(),
});

export const sessionInfoSchema = z.object({
  userId: z.number().nullable(),
  profileId: z.number().nullable(),
  isLoggedIn: z.boolean(),
  cart: sessionCartSchema.optional(),
  name: z.string().optional(),
  basicInfo: sessionUserBasicInfoSchema.optional(),
  gst: sessionGstSchema.optional(),
  assistedCustomer: sessionAssistedCustomerSchema.optional(),
});

export type SessionCartDto = z.infer<typeof sessionCartSchema>;
export type SessionAssistedCustomerDto = z.infer<
  typeof sessionAssistedCustomerSchema
>;
export type SessionUserBasicInfoDto = z.infer<
  typeof sessionUserBasicInfoSchema
>;
export type SessionGstDto = z.infer<typeof sessionGstSchema>;
export type SessionInfoDto = z.infer<typeof sessionInfoSchema>;
